import React from "react";
import PropTypes from "prop-types";
import MDTypography from "components/MDTypography";

const LanguageText = ({
  textMap = null,
  fallbackText = "N/A",
  variant = "body2",
  color = "black",
  ...otherProps
}) => {
  // Get current language from localStorage or default to 'en'
  const currentLang = localStorage.getItem("lang") || "en";

  // Get text in current language or fallback to the other language
  const getText = () => {
    if (!textMap || typeof textMap !== "object") {
      return fallbackText;
    }

    // Try current language first
    if (textMap[currentLang]) {
      return textMap[currentLang];
    }

    // Fallback to the other language
    const otherLang = currentLang === "en" ? "ar" : "en";
    if (textMap[otherLang]) {
      return textMap[otherLang];
    }

    // Last resort: check for any available text
    const availableText = textMap.en || textMap.ar || Object.values(textMap)[0];
    return availableText || fallbackText;
  };

  const text = getText();

  // Apply RTL direction for Arabic text
  const isArabic = textMap
    ? currentLang === "ar" || (!textMap[currentLang] && textMap.ar === text)
    : currentLang === "ar";

  return (
    <MDTypography
      variant={variant}
      color={color}
      sx={{
        direction: isArabic ? "rtl" : "ltr",
        textAlign: isArabic ? "right" : "left",
      }}
      {...otherProps}
    >
      {text}
    </MDTypography>
  );
};

LanguageText.propTypes = {
  textMap: PropTypes.object,
  fallbackText: PropTypes.string,
  variant: PropTypes.string,
  color: PropTypes.string,
};

export default LanguageText;
